import axios, { AxiosError } from "axios";

import { ERROR_CAUSES, ISystemApiError } from "@dl/declarations";
import { BROWSER_EVENTS } from "./constants";

export const baseURL = import.meta.env.VITE_API_BASE_URL;

const api = axios.create({
  baseURL: `${baseURL}/admin`,
  withCredentials: true,
  timeout: 10_000,
});

api.interceptors.response.use(
  function onFulfilled(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function onRejected(error: AxiosError<ISystemApiError>) {
    const cause = error.response?.data?.cause;
    // console.error("Error cause:", cause);

    // if ([401, 403].includes(error.response?.status || 0)) {
    //   window.dispatchEvent(new Event(BROWSER_EVENTS.UNAUTHORIZED));
    // }

    if (ERROR_CAUSES.CREDENTIALS_INVALID === cause || ERROR_CAUSES.CREDENTIALS_EXPIRED === cause) {
      window.dispatchEvent(new Event(BROWSER_EVENTS.UNAUTHORIZED));
    }

    // console.error("API Error:", error);
    // toastError({
    //   title:
    //     error?.response?.data?.message || error?.message || "An error occurred",
    // });
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // return error;

    return Promise.reject(
      Object.assign(
        new Error(
          error?.response?.data?.message ||
          error?.message ||
          "An error occurred",
          {
            cause,
          }
        ),
        {
          status: error?.response?.data?.statusCode || error?.response?.status,
          response: error?.response,
        },
      ),
    );
  },
);

export default api;
